import { ACCENT_COLOR, PANEL_COLOR, SURFACE_COLOR } from './styles/heritagePortraits.styles'

export const HERITAGE_PORTRAITS_BASE_PATH = '/heritageportraits'

// Palette aliases so non-styling callers can take a token without importing the styles module.
export const HERITAGE_PORTRAITS_SURFACE_COLOR = SURFACE_COLOR
export const HERITAGE_PORTRAITS_PANEL_COLOR = PANEL_COLOR
export const HERITAGE_PORTRAITS_ACCENT_COLOR = ACCENT_COLOR
